import React from 'react';
import { motion } from 'framer-motion';

const ResourcesPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <div className="pt-16 bg-[#FFFDF8] min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <motion.div {...fadeInUp} className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-[#0B1320] font-poppins mb-4">
            Wellness Resources
          </h1>
          <p className="text-xl text-[#4A4A4A] max-w-3xl mx-auto">
            Educational content and guides
          </p>
        </motion.div>
        
        <div className="text-center">
          <p className="text-[#4A4A4A]">Resources page content coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default ResourcesPage;